import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BadgeCheck, CheckCircle2, ShieldCheck, Mail } from "lucide-react";
import MarketingLayout from "@/components/MarketingLayout";
import { api } from "@/lib/api";

export default function SellerPolicy() {
  const navigate = useNavigate();
  const [policy, setPolicy] = useState(null);

  useEffect(() => { api.get("/seller/policies").then(setPolicy).catch(() => setPolicy(null)); }, []);

  return (
    <MarketingLayout>
      <div className="fade-up" data-testid="seller-policy-page">
        {/* Hero */}
        <div className="ss-card" style={{ padding: 34, background: "var(--brand)", color: "#fff" }}>
          <div style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "rgba(255,255,255,.14)", borderRadius: 999, padding: "6px 14px", fontSize: 12, fontWeight: 700, letterSpacing: 1, textTransform: "uppercase" }}>
            <BadgeCheck size={14} style={{ color: "var(--gold)" }} /> Verified seller standards
          </div>
          <h1 style={{ fontSize: 34, fontWeight: 800, marginTop: 16, lineHeight: 1.2 }}>{policy?.title || "SouqStream Seller Agreement"}</h1>
          <p style={{ marginTop: 14, fontSize: 16, lineHeight: 1.7, color: "rgba(255,255,255,.9)", maxWidth: 640 }}>
            {policy?.summary || "By getting verified you agree to uphold these standards for every sale on SouqStream."}
          </p>
          <div style={{ marginTop: 14, fontSize: 13, color: "rgba(255,255,255,.8)" }}>
            {policy ? `Version ${policy.version}${policy.effective_date ? ` · Effective ${policy.effective_date}` : ""}` : ""}
          </div>
        </div>

        {/* Policy points */}
        <div className="ss-card" style={{ padding: 24, marginTop: 16 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16 }}>
            <span style={{ width: 38, height: 38, borderRadius: 10, background: "var(--brand)", color: "#fff", display: "grid", placeItems: "center", flexShrink: 0 }}>
              <ShieldCheck size={19} />
            </span>
            <h2 style={{ fontSize: 20, fontWeight: 800 }}>What you agree to as a verified seller</h2>
          </div>
          {!policy ? (
            <div className="ss-muted" style={{ fontSize: 15 }}>Loading policy…</div>
          ) : (
            <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: 14 }} data-testid="policy-points">
              {policy.points.map((p, i) => (
                <li key={i} style={{ display: "flex", gap: 12, alignItems: "flex-start" }} data-testid={`policy-point-${i}`}>
                  <CheckCircle2 size={20} style={{ color: "var(--brand)", flexShrink: 0, marginTop: 2 }} />
                  <span style={{ fontSize: 15, lineHeight: 1.6, color: "var(--fg, #14231d)" }}>{p}</span>
                </li>
              ))}
            </ul>
          )}
        </div>

        {/* Contact */}
        <div className="ss-card" style={{ padding: 24, marginTop: 16 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
            <span style={{ width: 38, height: 38, borderRadius: 10, background: "var(--brand)", color: "#fff", display: "grid", placeItems: "center", flexShrink: 0 }}>
              <Mail size={19} />
            </span>
            <h2 style={{ fontSize: 20, fontWeight: 800 }}>Questions?</h2>
          </div>
          <p style={{ color: "var(--muted)", fontSize: 15, lineHeight: 1.7 }}>
            These standards work alongside our{" "}
            <span onClick={() => navigate("/terms")} style={{ color: "var(--brand)", fontWeight: 700, cursor: "pointer" }} data-testid="policy-terms-link">Terms of Service</span>.
            Reach us anytime through the{" "}
            <span onClick={() => navigate("/contact")} style={{ color: "var(--brand)", fontWeight: 700, cursor: "pointer" }} data-testid="policy-contact-link">Contact page</span>.
          </p>
        </div>
      </div>
    </MarketingLayout>
  );
}
